// src/hooks/countries/useDeleteCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteCountry } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useDeleteCountries = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteCountries,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteCountry,
        onSuccess: (response) => {
            toast.success(response?.message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete country");
        },
    });

    return {
        deleteCountries,
        isDelete: isPending || isLoading,
    };
};

export default useDeleteCountries;
